import React, { useEffect } from 'react';

// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, CircularProgress, Container, Divider, IconButton, Paper, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { pdfjs } from 'react-pdf';

import { useDispatch, useSelector } from 'react-redux';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import DownloadIcon from '@mui/icons-material/Download';
import { useDevice } from '../hooks/useResponsive';
import { MetaHelmet } from '../layouts/Helmet/Helmet';
import { getInspectionDocumentDetails } from '../server/api/inspectionBooking';
// import Scrollbar from '../components/scrollbar/Scrollbar';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function PdfViewPage() {
  const location = useLocation();
  // const [numPages, setNumPages] = useState(null);
  const navigate = useNavigate();
  const { isMobile } = useDevice();
  const params = useParams();
  const dispatch = useDispatch();

  // const { inspectionDocumentDetails } = useSelector((state) => ({
  //   inspectionBookingSingleViewDetails: state.Inspection.inspectionDocumentDetails,
  //   loading: state.Inspection.loading,
  // }));
  // console.log(numPages);
  const { verifyDetails } = useSelector((state) => ({
    verifyDetails:
      JSON.parse(localStorage.getItem('verifyDetails')) ||
      state.Inspection.verifyDetails ||
      state.InspectioninspectionDocumentDetails,
  }));

  useEffect(
    () => () => {
      if (location.pathname === '/pdf-view') {
        localStorage.removeItem('verifyDetails');
      }
    },
    [location.pathname]
  );
  // const onDocumentLoadSuccess = ({ Pages }) => {
  //   setNumPages(Pages);
  // };
  console.log(verifyDetails);
  useEffect(() => {
    const credentials = {
      documentId: params?.id,
      dispatch,
    };
    dispatch(getInspectionDocumentDetails(credentials));
  }, [dispatch, params?.id]);
  return (
    <>
      <MetaHelmet title={'Verify'} companyName={'Focus Motors'} />

      <StyledRoot className="bg-light ">
        <Container
          maxWidth="xl"
          sx={{
            padding: isMobile ? 'unset' : '0px 0px 500px 0px !important',
            position: 'relative',
            minHeight: isMobile
              ? verifyDetails?.pdf_url?.url
                ? '643vh'
                : '100vh'
              : verifyDetails?.pdf_url?.url
              ? '1790vh'
              : '100vh',
            backgroundColor: '#f0f1f3',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: isMobile ? 150 : 500,
              backgroundImage: 'url(/assets/images/Inspection/VerifyBanner.webp)',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          />
          <Container
            className=""
            maxWidth="md"
            sx={{
              mb: 4,
              position: 'absolute',
              top: isMobile ? 0 : verifyDetails?.pdf_url?.url ? '1%' : '15%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderRadius: isMobile ? 0 : '24px',
              backgroundColor: '#FFFFFF',
              px: '0px !important',
              ...(!verifyDetails?.pdf_url?.url && {
                height: isMobile ? '76vh' : 'auto',
                alignItems: isMobile ? 'center' : 'unset',
                display: isMobile ? 'flex' : '',
              }),
              ...(isMobile && {
                p: 2,
                px: 2,
                justifyContent: 'center',
              }),
            }}
          >
            <Paper
              elevation={3}
              sx={{
                borderRadius: isMobile ? 2 : 4,
                overflow: 'hidden',
                p: 0,
              }}
            >
              {/* Banner Image */}
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
                {/* Back button */}
                <Stack
                  direction="row"
                  alignItems="center"
                  onClick={() => navigate(-1)}
                  spacing={isMobile ? 0.5 : 1.2}
                  sx={{ cursor: 'pointer' }}
                >
                  <IconButton size="small" sx={{ p: 0 }}>
                    <ArrowBackIosNewIcon sx={{ fontSize: '12px', color: '#121212' }} />
                  </IconButton>
                  <Typography fontSize={14} fontWeight={500} color="#121212">
                    Back
                  </Typography>
                </Stack>

                {/* Right side buttons */}
                <Stack direction="row" spacing={2}>
                  {/* <Button
                  variant="contained"
                  startIcon={<PrintIcon />}
                  // onClick={onPrint}
                  sx={{
                    backgroundColor: '#FF9910',
                    '&:hover': { backgroundColor: '#F16400' },
                    borderRadius: '50px',
                    textTransform: 'none',
                    fontWeight: 600,
                  }}
                >
                  Print
                </Button> */}
                  {verifyDetails?.pdf_url?.url && (
                    <Button
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                      onClick={async () => {
                        const url = verifyDetails?.pdf_url?.url;
                        if (!url) {
                          console.error('PDF URL not found');
                          return;
                        }

                        try {
                          const response = await fetch(url, { mode: 'cors' });
                          const blob = await response.blob();
                          const blobUrl = window.URL.createObjectURL(blob);

                          const link = document.createElement('a');
                          link.href = blobUrl;
                          link.download = 'Inspection_Report.pdf'; // ✅ Change filename if needed
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);

                          window.URL.revokeObjectURL(blobUrl); // cleanup
                        } catch (err) {
                          console.error('Error downloading file:', err);
                        }
                      }}
                      sx={{
                        color: '#FF9910',
                        borderColor: '#FF9910',
                        borderRadius: '50px',
                        textTransform: 'none',
                        fontWeight: 600,
                        '&:hover': {
                          borderColor: '#F16400',
                          color: '#F16400',
                        },
                      }}
                    >
                      Download PDF
                    </Button>
                  )}
                </Stack>
              </Stack>
              <Divider sx={{ mb: 2 }} />
              {verifyDetails?.pdf_url?.url ? (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl={verifyDetails?.pdf_url?.url}
                    defaultScale={SpecialZoomLevel.PageWidth}
                    renderLoader={() => (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '400px', // Adjust based on viewer height
                        }}
                      >
                        <CircularProgress color="warning" />
                      </Box>
                    )}
                  />
                </Worker>
              ) : (
                //               <Scrollbar
                //               sx={{ maxHeight: 600 }}
                //               >

                //                 <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                //   <Viewer
                //     fileUrl={verifyDetails?.pdf_url?.url}
                //     defaultScale={SpecialZoomLevel.PageWidth}
                //     onDocumentLoad={onDocumentLoadSuccess}
                //   />
                // </Worker>
                //                 <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                //                   <Viewer fileUrl={verifyDetails?.pdf_url?.url} defaultScale={SpecialZoomLevel.PageWidth} />
                //                 </Worker>
                //               </Scrollbar>
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  spacing={2}
                  sx={{
                    border: '1px dashed #ccc',
                    borderRadius: 2,
                    p: 4,
                    textAlign: 'center',
                    backgroundColor: '#fafafa',
                    mx: isMobile ? 2 : 5,
                    my: isMobile ? 2 : 5,
                    minHeight: verifyDetails?.pdf_url?.url ? 'auto' : '400px',
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      backgroundColor: '#f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <PictureAsPdfIcon color="error" fontSize="large" />
                  </Box>

                  <Typography variant="h6" fontWeight="bold">
                    No PDF Available
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    There are no PDFs available at the moment.
                  </Typography>
                </Stack>
              )}
            </Paper>
          </Container>
        </Container>
      </StyledRoot>
    </>
  );
}
